module.exports = __webpack_public_path__ + "img/express.59e25f48.svg";